import { ReactElement } from 'react'
import { useStateValue } from 'contexts'

import ReauthModal from '../ReauthModal'

const ReauthModalListener = (): ReactElement | null => {
  const {
    selectors: { uiSelectors },
  } = useStateValue()

  const { isReauthModalVisible, onComplete, onError } =
    uiSelectors.reauthModalOptions ?? {}

  return isReauthModalVisible ? (
    <ReauthModal onComplete={onComplete} onError={onError} />
  ) : null
}

export default ReauthModalListener
